import { useState } from 'react'
import Modal from '@components/shared/Modal'

async function copyText(value) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value)
    return
  }

  const textarea = document.createElement('textarea')
  textarea.value = value
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('copy')
  textarea.remove()
}

export default function PortalTemporaryPasswordModal({ credential, onClose }) {
  const [copied, setCopied] = useState(false)

  if (!credential) return null

  const copy = async () => {
    try {
      await copyText(credential.senhaTemporaria)
      setCopied(true)
    } catch {
      setCopied(false)
    }
  }

  return (
    <Modal
      isOpen={Boolean(credential)}
      onClose={onClose}
      title="Senha temporária do Portal"
      subtitle={credential.email}
      icon="fa-key"
      size="small"
      closeOnOverlayClick={false}
      footer={
        <button type="button" className="btn btn-primary" onClick={onClose}>
          Já salvei a senha
        </button>
      }
    >
      <div className="portal-temporary-password-result portal-temporary-password-modal-result">
        <div className="portal-temporary-password-header">
          <span>Nova credencial de {credential.nome}</span>
        </div>
        <code>{credential.senhaTemporaria}</code>
        <small>
          Esta é a única exibição desta senha. Ao fechar o modal ela não poderá ser recuperada; se necessário, gere uma nova.
        </small>
        <button type="button" className="portal-approve-button portal-copy-password" onClick={copy}>
          <i className={`far ${copied ? 'fa-circle-check' : 'fa-copy'}`} /> {copied ? 'Senha copiada' : 'Copiar senha'}
        </button>
      </div>
    </Modal>
  )
}
